/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDialogCheck120 = forwardRef<SVGSVGElement, IconBaseProps>(function IconDialogCheck120(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 120 120" ref={ref}>
            <path
                d="M110 60c0 27.614-22.386 50-50 50S10 87.614 10 60s22.386-50 50-50 50 22.386 50 50ZM85.822 38.763a5 5 0 0 0-7.059.415L52.43 68.802 41.174 56.607a5 5 0 0 0-7.348 6.782l13.128 14.224a7.5 7.5 0 0 0 11.117-.104l28.166-31.687a5 5 0 0 0-.415-7.059Z"
                fill="#33B343"
            />
        </SVGContainer>
    );
});

export const IconDialogCheck = forwardRef<SVGSVGElement, IconBaseProps>(function IconDialogCheck(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '120':
            return <IconDialogCheck120 {...iconProps} />;
        default:
            return <IconDialogCheck120 {...iconProps} />;
    }
});
